import React from "react";
import classNames from "classnames";
import { NavBarProps } from "./PropsType";

export default function NavBar(props: NavBarProps) {
  const {
    center = "",
    className,
    fixed,
    left = "",
    right = "",
    prefixCls = "bm-NavBar",
  } = props;
  const styleClass = classNames(
    `${prefixCls}`,
    {
      [`${prefixCls}-fixed`]: fixed,
    },
    className
  );
  return (
    <div className={styleClass}>
      <div className={`${prefixCls}-inner`}>
        <div className={`${prefixCls}-left`}>{left}</div>
        <div className={`${prefixCls}-center`}>{center}</div>
        <div className={`${prefixCls}-right`}>{right}</div>
      </div>
    </div>
  );
}
